import React from "react";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { visibility } from "../../redux/slices/rightSideAd";
import "./AdminSettings.scss";
import { styled, Switch } from "@mui/material";
import { useMutation } from "@apollo/client";
import { UPDATE_ADMIN_NOTIFICATION_TOGGLE } from "./api/AdminSettings";
import dayjs from "dayjs";
import { setIsNotificationEnable } from "../../redux/slices/authSlice";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import { getScreenDimensions } from "../../utils/helper";
import { useNavigate } from "react-router-dom";
import { SCHOOL_ADMIN } from "../../utils/constants";

type UpdateAdminNotificationToggleInput = {
  saId: string; // UUID as a string
  saNotificationEnabled: boolean;
  saNotificationChangedTime: string;
};

type UpdateAdminNotificationToggleResponse = {
  updateSchoolAdminBySaId: {
    clientMutationId: string | null;
  };
};

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 45,
  height: 24,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    color:'#0B74BB',
    "&.Mui-checked": {
      transform: "translateX(20px)",
      color: '#0BBB25',
      "& + .MuiSwitch-track": {
        backgroundColor: "#F0F3F5",
        opacity: 1,
        border: 0,
        ...theme.applyStyles("dark", {
          backgroundColor: "#2ECA45",
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
    position: "relative",
    bottom: 2,
    right: 2,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#E9E9EA",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    ...theme.applyStyles("dark", {
      backgroundColor: "#39393D",
    }),
  },
}));

const AdminSettings = () => {
  const dispatch = useAppDispatch();
  dispatch(visibility({ isVisible: true }));
  const isNotificationEnable = useAppSelector((state) => state.auth.isNotificationEnabled)
  const adminId = useAppSelector((state) => state.auth.adminId);
  const navigate = useNavigate()
  const role = useAppSelector((state) => state.auth.role);


  const [updateNotificationToggle] = useMutation<
    UpdateAdminNotificationToggleResponse,
    UpdateAdminNotificationToggleInput
  >(UPDATE_ADMIN_NOTIFICATION_TOGGLE, {
    onCompleted: (data) => {
      // success("Updated Successfully!");
    },
    onError: (err) => {
      // error(err.message);
      console.log(err.message);
    },
  });

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setIsNotificationEnable(event.target.checked))
    try {
      await updateNotificationToggle({
        variables: {
          saId: adminId,
          saNotificationEnabled: event.target.checked,
          saNotificationChangedTime: dayjs().utc().format(),
        },
      });
    } catch (err) {
      console.error("Error in mutation:", err);
    }
  };

  return (
    <div className="notificaiton-container">
      {getScreenDimensions()?.isMobileScreen && (
        <div className="settingsMobileHeaderContainer">
          <div className="mobileSettingsTitleTextStyle">Settings</div>
          <MobileHeader />
        </div>
      )}
      <div className="notification-content-ctn">
        <div className="heading">
          <div className="title">Notification</div>
          <div className="sub-heading">
            Get notifications from the app and other senders
          </div>
        </div>
        <div className="toggle">
          {<span className="labels">OFF</span>}
          <AntSwitch
            checked={isNotificationEnable}
            onChange={handleChange}
            inputProps={{ "aria-label": "controlled" }}
          />
          {<span className="labels">ON</span>}
        </div>
      </div>
      {/* {role === SCHOOL_ADMIN && <span className="line"></span>}
      {role === SCHOOL_ADMIN &&  <div
        className="upload-materials"
        onClick={() => navigate("/admin-materials-upload/materials")}
      >
        Upload Materials
      </div>} */}
    </div>
  );
};

export default AdminSettings;
